import { render, staticRenderFns } from "./NavigationManagement.vue?vue&type=template&id=0918aef0&"
import script from "./NavigationManagement.vue?vue&type=script&lang=js&"
export * from "./NavigationManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports